// event-modal
(function(){


    function buildMilestoneSlick( ) {

        $('.milestone-list').slick({
            infinite: true,
            speed: 3000,
            slidesToShow: 3,
            slidesToScroll: 3,
            autoplay: true,
            autoplaySpeed: 2000,
            pauseOnHover:false,
            pauseOnFocus: false,
            prevArrow: '<div class="arrow-prev"><i class="fas fa-chevron-left"></i></div>',
            nextArrow: '<div class="arrow-next"><i class="fas fa-chevron-right"></i></div>',
            centerMode: false,
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        speed: 3000,
                        slidesToShow: 3,
                        slidesToScroll: 3
                    }
                },
                {
                    breakpoint: 576,
                    settings: {
                        speed: 2000,
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        });
    }

    // Setup Event List Slick Slide
    function buildEventSlick( ) {
        $('.event-list').slick({
            infinite: true,
            speed: 3000,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 3000,
            pauseOnHover:false,
            pauseOnFocus: false,
            prevArrow: '<div class="arrow-prev"><i class="fas fa-chevron-left"></i></div>',
            nextArrow: '<div class="arrow-next"><i class="fas fa-chevron-right"></i></div>',
            centerMode: false
        });

    }

    function buildEventPhotoGallerySlick() {
        $(".event-card-carousel").slick({
            dots: true,
            slidesToShow: 2,
            slidesToScroll: 2,
            infinite: true,
            speed: 1000,
            autoplay: true,
            autoplaySpeed: 2000,
            prevArrow: '<div class="arrow-prev"><i class="fas fa-chevron-left"></i></div>',
            nextArrow: '<div class="arrow-next"><i class="fas fa-chevron-right"></i></div>',
            responsive: [
                {
                    breakpoint: 576,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        });
    }




    $(function () {

        // Setup Milestone Slick Slide
        buildMilestoneSlick();

        // Setup Event Slick Slide
        buildEventSlick();

        // Setup Event Card Slick Slide
        buildEventPhotoGallerySlick();

    });


    function update_slick_arrow_positions( ) {

        let current_slick = $('.event-modal.show .slick-current');

        if ( current_slick.length > 0 ) {

            let event_image = current_slick.find('.event-image');

            // Calculate the arrow position.
            let position = event_image.height() / 2;

            $(".event-card-carousel .arrow-prev").css("top", position - 40 );
            $(".event-card-carousel .arrow-next").css("top", position - 40 );
        }
    }

    $('.event-modal').on('shown.bs.modal', function (e) {
        $(this).find('.event-card-carousel').slick('setPosition');
        update_slick_arrow_positions();

        // Stop Event Carousel
        $('.event-list').slick('slickPause');
    });

    $('.event-modal').on('hidden.bs.modal', function (e) {

        // Resume Event Carousel
        $('.event-list').slick('setPosition');
        $('.event-list').slick('slickPlay');
    });



    $('.event-card-carousel').on('breakpoint setPosition', function(event, slick, direction){
        update_slick_arrow_positions();
    });



})();
